export default "__VITE_ASSET__yPFuI1NM__"